module.exports = "<div class=\"minto-arrow-tooltip\" ng-style=\"vm.tooltipStyles['minto-arrow-tooltip']\">\n  <svg height=\"30\" width=\"40\" xmlns=\"http://www.w3.org/2000/svg\">\n    <circle cx=\"10\" cy=\"20\" r=\"2\" fill=\"#050e61\"/>\n    <circle cx=\"17\" cy=\"20\" r=\"2\" fill=\"#050e61\"/>\n    <circle cx=\"24\" cy=\"20\" r=\"2\" fill=\"#050e61\"/>\n    <polyline stroke=\"#050e61\" fill=\"none\" points=\"30,12 35,17 30,22\" stroke-width=\"3\"/>\n  </svg>\n  <div ng-bind-html=\"vm.tooltipText\" class=\"minto-arrow-tooltip__text\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/arrow-tooltip/arrow-tooltip.html
// module id = 892
// module chunks = 0